import { DefectTableParams } from '@core/protocol-pdf/protocol-defect-table-params';
import { ProtocolPdfResultDto } from './ProtocolPdfResultDto';

export class InspectionResultForCategoryDto {
  public isDefectCorrectionTable: boolean = false;
  public isFirstPathForCategory: boolean = false;
  public displayInspectionDataOnTopOfProtocolPdf: boolean = false;
  public defectTableParams: DefectTableParams | undefined;
  public defectsMap: Map<string, Map<string, ProtocolPdfResultDto[]>> | undefined;
}
